// frontend/src/pages/MemberLayout.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const MemberLayout = ({ children, activePage, pageTitle, breadcrumbs = [] }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('hopeSaccoUser');
    if (!storedUser) {
      navigate('/login');
      return;
    }
    const userData = JSON.parse(storedUser);

    // Allow member, admin, and official roles
    const allowedRoles = ['member', 'admin', 'official'];
    if (!allowedRoles.includes(userData.role)) {
      navigate('/login');
      return;
    }

    setUser(userData);
  }, [navigate]);

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      localStorage.clear();
      navigate('/login');
    }
  };

  if (!user) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="admin-dashboard">
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="logo">
            <span className="logo-icon">💰</span>
            <span className="logo-text">Hope SACCO</span>
          </div>
          <div className="user-role-badge" style={{ fontSize: '1rem', color: '#ffffff', marginTop: '0.5rem', fontWeight: '600' }}>
            Member Portal
          </div>
        </div>
 
        <nav className="sidebar-nav">
          <a
            href="#"
            onClick={(e) => { e.preventDefault(); navigate('/member/dashboard'); }}
            className={`nav-item ${activePage === 'dashboard' ? 'active' : ''}`}
          >
            <span className="nav-icon">🏠</span>
            <span className="nav-text">My Dashboard</span>
          </a>

          <a
            href="#"
            onClick={(e) => { e.preventDefault(); navigate('/member/profile'); }}
            className={`nav-item ${activePage === 'profile' ? 'active' : ''}`}
          >
            <span className="nav-icon">👤</span>
            <span className="nav-text">My Profile</span>
          </a>

          <a
            href="#"
            onClick={(e) => { e.preventDefault(); navigate('/member/loans'); }}
            className={`nav-item ${activePage === 'loans' ? 'active' : ''}`}
          >
            <span className="nav-icon">💵</span>
            <span className="nav-text">My Loans</span>
          </a>

          <a
            href="#"
            onClick={(e) => { e.preventDefault(); navigate('/member/statement'); }}
            className={`nav-item ${activePage === 'statement' ? 'active' : ''}`}
          >
            <span className="nav-icon">📄</span>
            <span className="nav-text">My Statement</span>
          </a>

          {/* ✅ NEW MENU ITEM: Request Loan (placed after My Statement) */}
          <a
            href="#"
            onClick={(e) => { e.preventDefault(); navigate('/member/request-loan'); }}
            className={`nav-item ${activePage === 'request-loan' ? 'active' : ''}`}
          >
            <span className="nav-icon">📝</span>
            <span className="nav-text">Request Loan</span>
          </a>
        </nav>

        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <span className="nav-icon">🚪</span>
            <span className="nav-text">Logout</span>
          </button>
        </div>
      </aside>

      <main className="main-content">
        <header className="top-header">
          <div className="header-left">
            {breadcrumbs.length > 0 && (
              <div className="breadcrumbs">
                {breadcrumbs.map((crumb, index) => (
                  <span key={index}>
                    {crumb.link ? (
                      <a href="#" onClick={(e) => { e.preventDefault(); navigate(crumb.link); }}>
                        {crumb.label}
                      </a>
                    ) : (
                      <span>{crumb.label}</span>
                    )}
                    {index < breadcrumbs.length - 1 && <span className="separator"> / </span>}
                  </span>
                ))}
              </div>
            )}
            {pageTitle && <h1 className="page-title">{pageTitle}</h1>}
          </div>
          <div className="header-right">
            <div className="user-info">
              <span className="user-name">{user.profile?.displayName || user.email}</span>
              <span className="user-role">{user.profile?.memberId || 'Member'}</span>
            </div>
          </div>
        </header>

        <div className="content-wrapper">
          {children}
        </div>
      </main>
    </div>
  );
};

export default MemberLayout;
